export default __webpack_public_path__ + "static/media/IconProducts.c710637a.svg";